// extracted by mini-css-extract-plugin
module.exports = {"hidden":"warning_hidden__pdDZ3","textEmphasis":"warning_textEmphasis__6pBBP","warningArea":"warning_warningArea__557rc","text":"warning_text__efQuS"};